import React, { useCallback, useRef } from "react";

export default function useRefs<RefType>(): [
    (key: React.Key) => React.RefObject<RefType>,
    (key: React.Key) => void,
] {
    const refs = useRef(new Map<React.Key, React.RefObject<RefType>>());

    const getRef = useCallback((key: React.Key) => {
        if (!refs.current.has(key)) {
            refs.current.set(key, React.createRef<RefType>());
        }
        return refs.current.get(key)!;
    }, []);

    const removeRef = useCallback((key: React.Key) => {
        refs.current.delete(key);
    }, []);

    return [getRef, removeRef];
}
